import { Link } from "react-router-dom";
import { Card } from "./ui/card";
import { Lock, Shield } from "lucide-react";
const AdminLoginNotice = () => {
  return <div className="fixed bottom-4 right-4 z-40 max-w-sm animate-fade-in">
      
    </div>;
};
export default AdminLoginNotice;